import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CleverTeacher } from '../../core/models/clever-teacher.model';
import { SSOCredentials, SSOError } from '../../core/models/credentials.model';
import {catchError, retry, switchMap} from 'rxjs/operators';
import { of } from 'rxjs';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class CleverService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  getUserInfo(bearerToken: string) {
    let reqOptions = {
      headers: { 'Access-Control-Allow-Origin' : '*' },
    }

    return  this.httpClient.post(environment.EC2URL + 'clever/info', { bearerToken }, reqOptions).pipe(
      retry(2),
    );
  }

  getTeachers() {
    const reqOptions = {
      withCredentials: true,
      headers: {
        'Access-Control-Allow-Origin' : '*',
        'Content-Type': 'application/json',
      }
    } ;

    return  this.httpClient.get<{ [ key: string ]: CleverTeacher }>(environment.EC2URL + 'clever/student/teachers', reqOptions);
  }

  rosterStudent(student: SSOCredentials) {
    const reqOptions = {
      withCredentials: true,
      headers: {
        'Access-Control-Allow-Origin' : '*',
        'Content-Type': 'application/json',
      }
    } ;

    return this.httpClient.post(`${environment.EC2URL}clever/student/roster`, { student: student }, reqOptions).pipe(
      switchMap((userInfo) => {
        return of({ userObj: userInfo }) ;
      }),
      catchError((error) => {
        let err: SSOError ;
        if (error.status === 403)
        {
          err = {
            message: 'We could not log you in with Clever',
            details: error.error?.message ? error.error.message : 'Please make sure your Clever account is logged in and try again',
            showRetry: true,
          }
        }
        else if (error.status === 400)
        {
          err = {
            message: 'We could not create your account',
            details: error.error?.message ? error.error.message : 'We were unable to find your Teacher so we could not create your account, please ask for help!',
            showRetry: true,
          }
        }
        else
        {
          err = {
            message: 'We could not create your account',
            details: error.error?.message ? error.error.message : 'Something happened while trying to create your account, please ask your teacher to let us know!',
            showRetry: true,
          }
        }

        Sentry.captureException(error, {
          tags: {
            section: 'clever',
            action: 'roster-student',
          },
          contexts: {
            roster: {
              ssoId: student.ssoId,
              account: student.account,
              authorizedBy: student.authorizedBy,
              provider: student.provider,
            },
          },
        }) ;

        return of({ error: err }) ;
      })
    ) ;
  }
}
